/* Shared company information constants used across invoices, quotes, and email services
   Updated: correspondence address (Galileistraat 1N) for mail and administration. */

export const COMPANY_INFO = {
  name: 'Buitn Planten',
  parentBrand: 'Buitn',
  address: 'Galileistraat 1N',
  postalCode: '7701 SK',
  city: 'Dedemsvaart',
  country: 'Nederland',
  kvk: '87887991',
  btw: 'NL004509749B42',
  email: 'info@buitnplanten.nl',
  website: 'buitnplanten.nl',
  phone: '+31 85 02 33 564',
  bankAccount: 'NL11KNAB0800375904',
  bankAccountName: 'Buitn Groep',
  bankName: 'Knab',
};
